import { useContext as i, useMemo as c } from "react";
import { ThemeConfigContext as u } from "../assets/css/globalTheme.mjs";
import { EScene as r } from "../common/type.mjs";
import l from "../utils/themeUtil.mjs";
const E = function(e) {
  const t = i(u);
  return c(() => {
    var m;
    let o = t.scene;
    const s = e.theme ?? t.theme, n = l(e.template);
    return o === r.KEEN && (o = r.CAMOVUE), (m = n == null ? void 0 : n[o]) == null ? void 0 : m[s];
  }, [e.template, e.theme, t.scene, t.theme]);
};
export {
  E as useTheme
};
//# sourceMappingURL=useTheme.mjs.map
